export default __webpack_public_path__ + "static/media/suitGlowImg.bd122008.png";